import React from 'react';
import './MoreInfo.css';

const MoreInfo = ({ translations }) => {
  return (
    <div className="more-info-container">
      <div>
        <h2>
          {translations?.moreInfo?.title || 'Hur snabbt kan jag få mitt presentkort?'}
        </h2>
      </div>
      <div>
        {translations?.moreInfo?.body ||
          'Du kan vanligtvis slutföra alla nödvändiga sponsrade erbjudanden inom 5–7 dagar (vissa kan ta upp till 60 dagar att slutföra). När du har slutfört det nödvändiga antalet erbjudanden måste du slutföra anspråksprocessen för incitamentet, vilket kräver ID-verifiering. Det tar vanligtvis vårt kundtjänstteam 5–7 dagar att verifiera och leverera ditt incitament.'}
      </div>
    </div>
  );
};

export default MoreInfo;
